module.exports = __webpack_public_path__ + "static/media/microloan-icon.01d5c840.svg";